import * as React from "react";
import mergeStyles from "../../util/mergeStyles";

type Props = {
  style?: React.CSSProperties;
  className?: string;
  size: number | string;
};

export const Analytics = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g
      id="analytics-20px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" fillRule="nonzero">
        <rect
          id="Rectangle-2"
          fill="currentColor"
          x="4.375"
          y="8.4375"
          width="2.5"
          height="7.5"
        />
        <rect
          id="Rectangle-2"
          fill="currentColor"
          x="13.125"
          y="10.9375"
          width="2.5"
          height="5"
        />
        <rect
          id="Rectangle-2"
          fill="currentColor"
          x="8.75"
          y="4.6875"
          width="2.5"
          height="11.25"
        />
      </g>
    </g>
  </svg>
);

export const Author = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g
      id="auteursomgeving-20px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="pencil"
        transform="translate(9.450387, 10.450387) rotate(45.000000) translate(-9.450387, -10.450387) translate(7.585522, -1.049613)"
        fillRule="nonzero"
        stroke="currentColor"
        strokeWidth="2"
      >
        <polygon
          id="Rectangle"
          points="0 5.59459459 3.72972973 5.59459459 3.72972973 20.8243243 1.86486486 22.7881387 0 20.8243243"
        />
        <path
          d="M3.72972973,2.56054688 L0,2.56054688 L0,1 C-6.76353751e-17,0.44771525 0.44771525,-1.20591542e-16 1,-2.22044605e-16 L2.72972973,-2.22044605e-16 C3.28201448,-3.23497668e-16 3.72972973,0.44771525 3.72972973,1 L3.72972973,2.56054688 Z"
          id="Rectangle-2"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export const Admins = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g
      id="beheerders-20px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group"
        transform="translate(3.000000, 1.000000)"
        fillRule="nonzero"
      >
        <rect
          id="Rectangle-3"
          stroke="currentColor"
          strokeWidth="2"
          x="0"
          y="6"
          width="14"
          height="12"
          rx="2"
        />
        <circle id="Oval" fill="currentColor" cx="7" cy="12" r="2" />
        <path
          d="M3,6 C3,2 4.33333333,0 7,0 C9.66666667,0 11,2 11,6"
          id="Line"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="square"
        />
      </g>
    </g>
  </svg>
);

export const Chat = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="chat-20px"
        transform="translate(0.000000, -1.000000)"
        fillRule="nonzero"
      >
        <g id="Group" transform="translate(0.000000, 1.000000)">
          <path
            d="M3,-3.37812983e-05 L17.0000004,-3.38750194e-05 C18.6568547,-3.38750194e-05 20.0000004,1.34311188 20.0000004,2.99996612 C20.0000004,2.99996615 20.0000004,2.99996619 20.0000004,2.99996622 L20,11 C19.9999999,12.6568542 18.6568542,13.9999999 17,13.9999999 L10.517289,14 C9.85494754,14 9.21122527,14.2191919 8.68651633,14.6233908 L4.72216797,17.6772461 L4.72216797,14 C4.14811198,14 3.57405599,14 3,14 L3,14 C1.34314575,14 -1.7003404e-14,12.6568542 -2.30926389e-14,11 L-6.03961325e-14,2.99996622 C-6.50137852e-14,1.34311197 1.34314575,-3.37812983e-05 3,-3.37812983e-05 Z"
            id="Rectangle"
            fill="currentColor"
          />
          <circle
            id="Oval"
            fill="#FFFFFF"
            cx="5.83333333"
            cy="7.16666667"
            r="1.16666667"
          />
          <circle
            id="Oval"
            fill="#FFFFFF"
            cx="10.1666667"
            cy="7.16666667"
            r="1.16666667"
          />
          <circle
            id="Oval"
            fill="#FFFFFF"
            cx="14.5"
            cy="7.16666667"
            r="1.16666667"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const Bills = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g
      id="facturatie-20px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" fillRule="nonzero">
        <path
          d="M10.2298625,9.34814815 C8.89194499,8.99851852 8.46168959,8.63703704 8.46168959,8.07407407 C8.46168959,7.42814815 9.05697446,6.97777778 10.0530452,6.97777778 C11.1021611,6.97777778 11.4911591,7.48148148 11.5265226,8.22222222 L12.8290766,8.22222222 C12.7878193,7.20296296 12.1689587,6.26666667 10.9371316,5.96444444 L10.9371316,4.66666667 L9.16895874,4.66666667 L9.16895874,5.94666667 C8.02554028,6.19555556 7.10609037,6.94222222 7.10609037,8.08592593 C7.10609037,9.45481481 8.23182711,10.1362963 9.8762279,10.5333333 C11.3497053,10.8888889 11.6444008,11.4103704 11.6444008,11.9614815 C11.6444008,12.3703704 11.3555992,13.0222222 10.0530452,13.0222222 C8.8388998,13.0222222 8.36149312,12.477037 8.29666012,11.7777778 L7,11.7777778 C7.07072692,13.0755556 8.03732809,13.8044444 9.16895874,14.0474074 L9.16895874,15.3333333 L10.9371316,15.3333333 L10.9371316,14.0592593 C12.086444,13.84 13,13.1703704 13,11.9555556 C13,10.2725926 11.56778,9.69777778 10.2298625,9.34814815 Z"
          id="Shape"
          fill="currentColor"
        />
        <circle
          id="Oval"
          stroke="currentColor"
          strokeWidth="2"
          cx="10"
          cy="10"
          r="9"
        />
      </g>
    </g>
  </svg>
);

export const Home = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g
      id="home-20px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="home-outline"
        transform="translate(0.000000, 1.000000)"
        fill="currentColor"
        fillRule="nonzero"
      >
        <path
          d="M7.49633789,17.2059208 L7.49633789,10.8269478 L8.93883498,10.8269478 L11.0611651,10.8269478 L12.5309753,10.8269478 L12.5309753,17.2059208 L15.3405762,17.2059208 C16.0248524,17.2059208 16.3669905,16.8825503 16.3669905,16.2358093 L16.3669905,8.60493889 L10.0000001,2.22596588 L3.63300959,8.60493889 L3.63300959,16.2379456 C3.63300959,16.8832624 3.98809221,17.2059208 4.69825745,17.2059208 L6.81650482,17.2059208 L7.49633789,17.2059208 Z M11.7036438,1.06028297 L20,9.3938198 L18.0726539,9.3938198 L18.0726539,16.5718079 C18.0726539,17.8523673 17.470138,18.4926471 16.2651062,18.4926471 L11.0090817,18.4926471 L11.0090817,12.4267622 L8.99091826,12.4267622 L8.99091826,18.4926471 L3.73100281,18.4926471 C2.52856501,18.4926471 1.92734612,17.8493664 1.92734612,16.5628052 L1.92734612,9.3938198 L0,9.3938198 L8.31788274,1.06028297 C8.91551088,0.390608239 9.47621663,0.055770874 10,0.055770874 C10.5237834,0.055770874 11.0916646,0.390608239 11.7036438,1.06028297 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

export const IO = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g
      id="io-center-20px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <g
        id="Group"
        transform="translate(2.000000, 3.000000)"
        fillRule="nonzero"
        stroke="currentColor"
        strokeWidth="2"
      >
        <g id="arrow" transform="translate(0.000000, 2.000000)">
          <polyline
            id="Line-2"
            points="0.153020517 7.5675601 4.13155395 11.3540934 8.11008739 7.5675601"
          />
          <path d="M4.13155395,10.5352307 L4.13155395,0.148383531" id="Line" />
        </g>
        <g
          id="arrow"
          transform="translate(12.500000, 6.000000) scale(1, -1) translate(-12.500000, -6.000000) translate(8.000000, 0.000000)"
        >
          <polyline
            id="Line-2"
            points="0.153020517 7.5675601 4.13155395 11.3540934 8.11008739 7.5675601"
          />
          <path d="M4.13155395,10.5352307 L4.13155395,0.148383531" id="Line" />
        </g>
      </g>
    </g>
  </svg>
);

export const LearningApps = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g
      id="learning-apps-20px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" fill="currentColor" fillRule="nonzero">
        <rect
          id="Rectangle-4"
          x="10.4918033"
          y="11.8032787"
          width="8.19672131"
          height="8.19672131"
          rx="2"
        />
        <rect
          id="Rectangle-4"
          x="0"
          y="2.62295082"
          width="8.19672131"
          height="8.19672131"
          rx="2"
        />
        <rect
          id="Rectangle-4"
          x="0"
          y="11.8032787"
          width="8.19672131"
          height="8.19672131"
          rx="2"
        />
        <rect
          id="Rectangle-4"
          transform="translate(14.648416, 5.795957) rotate(45.000000) translate(-14.648416, -5.795957) "
          x="10.5500556"
          y="1.69759657"
          width="8.19672131"
          height="8.19672131"
          rx="2"
        />
      </g>
    </g>
  </svg>
);

export const LearningPlaylist = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g
      id="learning-playlist-20px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group"
        transform="translate(0.000000, 0.983333)"
        fillRule="nonzero"
      >
        <path
          d="M18.1,16.3 L18.1,17.1483398 C18.1,17.7006246 17.6522847,18.1483398 17.1,18.1483398 L2.9,18.1483398 C2.34771525,18.1483398 1.9,17.7006246 1.9,17.1483398 L1.9,16.3"
          id="Rectangle"
          stroke="currentColor"
        />
        <path
          d="M1,0 L19,0 C19.5522847,-1.01453063e-16 20,0.44771525 20,1 L20,15.6666667 C20,16.2189514 19.5522847,16.6666667 19,16.6666667 L1,16.6666667 C0.44771525,16.6666667 1.04869017e-15,16.2189514 0,15.6666667 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z M13.5888889,8.38888889 L7.01111111,4.68888889 L7.01111111,12.0888889 L13.5888889,8.38888889 Z"
          id="Combined-Shape"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export const Library = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g
      id="library-20px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group"
        transform="translate(1.000000, 1.000000)"
        fillRule="nonzero"
        stroke="currentColor"
        strokeWidth="2"
      >
        <circle id="Oval-3" cx="7.681818" cy="7.681818" r="7.681818" />
        <path
          d="M15.3727816,12.3303531 L15.3727816,12.3303531 C15.67668,12.26078 15.9794385,12.4507381 16.0490116,12.7546364 C16.0576712,12.7924618 16.0624075,12.8310793 16.0631453,12.8698763 L16.1580412,17.8596999 C16.1655347,18.2537242 15.8521896,18.5792187 15.4581653,18.5867122 C15.4536431,18.5867982 15.4491202,18.5868412 15.4445971,18.5868412 L15.4445971,18.5868412 C15.0425178,18.5868412 14.716168,18.2616498 14.7147381,17.859573 L14.6980971,13.1800472 C14.6966528,12.7739022 14.9768765,12.4209899 15.3727816,12.3303531 Z"
          id="Rectangle-3"
          fill="currentColor"
          transform="translate(15.428132, 15.451417) rotate(-45.000000) translate(-15.428132, -15.451417) "
        />
      </g>
    </g>
  </svg>
);

export const Team = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g
      id="mijn-team-20px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group"
        transform="translate(0.000000, 1.000000)"
        fill="currentColor"
        fillRule="nonzero"
      >
        <path
          d="M0.310942537,10.50288 C1.93520778,9.63211428 3.56993046,9.16924732 5.23809524,9.20896553 C6.36404052,9.23577375 7.45531025,9.4675447 8.51190441,9.90427839 C7.19549802,10.1915635 6.22621819,10.4782111 5.60406494,10.7642212 C4.93705944,11.0708503 3.97260113,11.6731614 2.71069001,12.5711545 C2.1774128,12.1115379 1.37749697,11.4221131 0.310942537,10.50288 Z"
          id="Line"
          strokeLinecap="square"
        />
        <path
          d="M5.23809524,7.3015873 C5.66330756,7.3015873 6.07154123,7.22889303 6.45104638,7.09525434 C6.04239795,6.16265151 6.0111084,5.19002279 6.35717773,4.17736816 C6.70324707,3.16471354 7.38842512,2.38782798 8.41271189,1.84671148 C7.78456215,0.743743142 6.59818395,0 5.23809524,0 C3.22181758,0 1.58730159,1.63451599 1.58730159,3.65079365 C1.58730159,5.66707131 3.22181758,7.3015873 5.23809524,7.3015873 Z"
          id="Oval-2"
        />
        <path
          d="M11.3785182,9.8762104 C12.6003079,9.40172712 13.8339235,9.17931216 15.0793651,9.20896553 C16.7173251,9.24796458 18.2419564,9.7696781 19.7331504,10.676192 C18.6775044,11.781598 17.9596526,12.5152867 17.5795952,12.877258 C16.5077887,11.9948495 15.4434965,11.2933115 14.3867187,10.772644 C13.6321208,10.4008586 12.6293873,10.1020473 11.3785182,9.8762104 Z"
          id="Line"
          strokeLinecap="square"
        />
        <path
          d="M15.0793651,7.3015873 C17.0956427,7.3015873 18.7301587,5.66707131 18.7301587,3.65079365 C18.7301587,1.63451599 17.0956427,0 15.0793651,0 C13.7600065,0 12.6041102,0.699864814 11.962673,1.74859745 C13.0188891,2.19508913 13.7809855,2.99554443 14.2489624,4.14996338 C14.6748566,5.20057157 14.612438,6.22093697 14.0617065,7.21105957 C14.3584912,7.2889696 14.7581343,7.3015873 15.0793651,7.3015873 Z"
          id="Oval-2"
        />
        <circle id="Oval-2" cx="10.1507935" cy="5.6507935" r="3.1507935" />
        <path
          d="M3.49206349,13.2458889 C5.72630023,11.5576642 8.00143251,10.7411236 10.3174603,10.7962671 C12.6334881,10.8514106 14.8028003,11.7737713 16.8253968,13.5633492 C14.6644469,15.5927638 12.4422247,16.5802866 10.1587302,16.5259177 C7.87523564,16.4715487 5.65301342,15.3782058 3.49206349,13.2458889 Z"
          id="Line"
        />
      </g>
    </g>
  </svg>
);

export const Organisation = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <defs>
      <path
        d="M0,0 L10,0 L10,18.75 L0,18.75 L0,0 Z M1.875,10 L1.875,12.1875 L4.0625,12.1875 L4.0625,10 L1.875,10 Z M1.875,14.0625 L1.875,16.25 L4.0625,16.25 L4.0625,14.0625 L1.875,14.0625 Z M5.625,10 L5.625,12.1875 L7.8125,12.1875 L7.8125,10 L5.625,10 Z M5.625,14.0625 L5.625,16.25 L7.8125,16.25 L7.8125,14.0625 L5.625,14.0625 Z M1.875,1.875 L1.875,4.0625 L4.0625,4.0625 L4.0625,1.875 L1.875,1.875 Z M1.875,5.9375 L1.875,8.125 L4.0625,8.125 L4.0625,5.9375 L1.875,5.9375 Z M5.625,1.875 L5.625,4.0625 L7.8125,4.0625 L7.8125,1.875 L5.625,1.875 Z M5.625,5.9375 L5.625,8.125 L7.8125,8.125 L7.8125,5.9375 L5.625,5.9375 Z"
        id="path-1"
      />
    </defs>
    <g
      id="organisatiestructuur-20px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-2" transform="translate(0.000000, 1.000000)">
        <rect
          id="Rectangle-5"
          stroke="currentColor"
          fillRule="nonzero"
          x="8.3125"
          y="8"
          width="11.1875"
          height="10.25"
        />
        <rect
          id="Rectangle"
          fill="currentColor"
          fillRule="nonzero"
          x="11.25"
          y="10"
          width="2.1875"
          height="2.1875"
        />
        <rect
          id="Rectangle"
          fill="currentColor"
          fillRule="nonzero"
          x="11.25"
          y="14.0625"
          width="2.1875"
          height="2.1875"
        />
        <rect
          id="Rectangle"
          fill="currentColor"
          fillRule="nonzero"
          x="15"
          y="10"
          width="2.1875"
          height="2.1875"
        />
        <rect
          id="Rectangle"
          fill="currentColor"
          fillRule="nonzero"
          x="15"
          y="14.0625"
          width="2.1875"
          height="2.1875"
        />
        <g id="Group">
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1" />
          </mask>
          <use
            id="Combined-Shape"
            fill="currentColor"
            fillRule="nonzero"
            xlinkHref="#path-1"
          />
          <g
            id="Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-Mask"
            transform="translate(1.000000, 1.000000)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const Settings = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g
      id="settings-20px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M17.7144667,10 C17.7144667,9.6625 17.6887518,9.3375 17.637322,9.025 L19.8102301,7.375 C20.0030918,7.225 20.0545216,6.95 19.9388046,6.7375 L17.8816135,3.275 C17.753039,3.05 17.4830327,2.975 17.2515987,3.05 L14.6929672,4.05 C14.1529546,3.65 13.587227,3.325 12.9572122,3.075 L12.5714889,0.425 C12.5329166,0.175 12.31434,0 12.0571911,0 L7.94280888,0 C7.68566,0 7.47994088,0.175 7.44136855,0.425 L7.05564522,3.075 C6.42563044,3.325 5.84704544,3.6625 5.31989021,4.05 L2.76125876,3.05 C2.52982476,2.9625 2.25981843,3.05 2.13124398,3.275 L0.0740528683,6.7375 C-0.0545215764,6.9625 -0.00309179853,7.225 0.202627313,7.375 L2.37553543,9.025 C2.32410565,9.3375 2.28553332,9.675 2.28553332,10 C2.28553332,10.325 2.31124821,10.6625 2.36267798,10.975 L0.189769869,12.625 C-0.00309179853,12.775 -0.0545215764,13.05 0.0611954238,13.2625 L2.11838654,16.725 C2.24696098,16.95 2.51696732,17.025 2.74840132,16.95 L5.30703277,15.95 C5.84704544,16.35 6.41277299,16.675 7.04278777,16.925 L7.42851111,19.575 C7.47994088,19.825 7.68566,20 7.94280888,20 L12.0571911,20 C12.31434,20 12.5329166,19.825 12.5586314,19.575 L12.9443548,16.925 C13.5743696,16.675 14.1529546,16.3375 14.6801098,15.95 L17.2387412,16.95 C17.4701752,17.0375 17.7401816,16.95 17.868756,16.725 L19.9259471,13.2625 C20.0545216,13.0375 20.0030918,12.775 19.7973727,12.625 L17.6501795,10.975 C17.6887518,10.6625 17.7144667,10.3375 17.7144667,10 Z M10,13.75 C7.87852166,13.75 6.14276666,12.0625 6.14276666,10 C6.14276666,7.9375 7.87852166,6.25 10,6.25 C12.1214783,6.25 13.8572333,7.9375 13.8572333,10 C13.8572333,12.0625 12.1214783,13.75 10,13.75 Z"
        id="Shape"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export const User = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g
      id="user-20px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" fillRule="nonzero" stroke="currentColor" strokeWidth="2">
        <circle id="Oval" cx="10" cy="10" r="9" />
        <circle id="Oval-2" fill="currentColor" cx="10" cy="7.5" r="2.8125" />
        <path
          d="M3.4375,15.8514219 C5.63682679,14.1895757 7.87641012,13.3857935 10.15625,13.4400754 C12.4360899,13.4943573 14.5104714,14.2981395 16.3793945,15.8514219 C14.3742798,18.0574602 12.2478149,19.1337196 10,19.0802002 C7.75218509,19.0266808 5.56468509,17.9504214 3.4375,15.8514219 Z"
          id="Line"
          fill="currentColor"
          strokeLinecap="square"
        />
      </g>
    </g>
  </svg>
);

export const Help = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group" fillRule="nonzero" stroke="currentColor" strokeWidth="2">
        <circle id="Oval" cx="10" cy="10" r="9" />
      </g>
      <path
        d="M8.2035,6.7675 C8.32816729,6.65749945 8.46474926,6.55300049 8.61325,6.454 C8.76175074,6.35499951 8.92216581,6.2688337 9.0945,6.1955 C9.26683419,6.1221663 9.45383233,6.06441688 9.6555,6.02225 C9.85716767,5.98008312 10.0753322,5.959 10.31,5.959 C10.6290016,5.959 10.919582,6.00299956 11.18175,6.091 C11.443918,6.17900044 11.6684991,6.30458252 11.8555,6.46775 C12.0425009,6.63091748 12.1873328,6.82799884 12.29,7.059 C12.3926672,7.29000116 12.444,7.54849857 12.444,7.8345 C12.444,8.11316806 12.4036671,8.35424898 12.323,8.55775 C12.2423329,8.76125102 12.1405839,8.93816592 12.01775,9.0885 C11.8949161,9.23883409 11.7620007,9.36899945 11.619,9.479 C11.4759993,9.58900055 11.340334,9.69258285 11.212,9.78975 C11.083666,9.88691715 10.9727505,9.98224953 10.87925,10.07575 C10.7857495,10.1692505 10.7298334,10.2746661 10.7115,10.392 L10.585,11.195 L9.6555,11.195 L9.562,10.2985 C9.55833332,10.2801666 9.5565,10.2645834 9.5565,10.25175 L9.5565,10.205 C9.5565,10.0436659 9.59683293,9.90341726 9.6775,9.78425 C9.75816707,9.66508274 9.85899939,9.55325052 9.98,9.44875 C10.1010006,9.34424948 10.231166,9.2425005 10.3705,9.1435 C10.509834,9.04449951 10.6399994,8.93725058 10.761,8.82175 C10.8820006,8.70624942 10.9828329,8.5751674 11.0635,8.4285 C11.1441671,8.2818326 11.1845,8.10950099 11.1845,7.9115 C11.1845,7.77949934 11.1597502,7.66125052 11.11025,7.55675 C11.0607498,7.45224948 10.9920004,7.36241704 10.904,7.28725 C10.8159996,7.21208296 10.7105839,7.15433354 10.58775,7.114 C10.4649161,7.07366647 10.3320007,7.0535 10.189,7.0535 C9.97999895,7.0535 9.80308406,7.07641644 9.65825,7.12225 C9.51341594,7.16808356 9.39058384,7.21941638 9.28975,7.27625 C9.18891616,7.33308362 9.10366701,7.38441644 9.034,7.43025 C8.96433299,7.47608356 8.90200028,7.499 8.847,7.499 C8.71499934,7.499 8.61966696,7.44400055 8.561,7.334 L8.2035,6.7675 Z M9.243,13.252 C9.243,13.1383328 9.26408312,13.0301672 9.30625,12.9275 C9.34841688,12.8248328 9.40708296,12.7368337 9.48225,12.6635 C9.55741704,12.5901663 9.64633282,12.5315002 9.749,12.4875 C9.85166718,12.4434998 9.96166608,12.4215 10.079,12.4215 C10.1926672,12.4215 10.3008328,12.4434998 10.4035,12.4875 C10.5061672,12.5315002 10.5941663,12.5901663 10.6675,12.6635 C10.7408337,12.7368337 10.7994998,12.8248328 10.8435,12.9275 C10.8875002,13.0301672 10.9095,13.1383328 10.9095,13.252 C10.9095,13.3693339 10.8875002,13.4784162 10.8435,13.57925 C10.7994998,13.6800838 10.7408337,13.7671663 10.6675,13.8405 C10.5941663,13.9138337 10.5061672,13.9715831 10.4035,14.01375 C10.3008328,14.0559169 10.1926672,14.077 10.079,14.077 C9.96166608,14.077 9.85166718,14.0559169 9.749,14.01375 C9.64633282,13.9715831 9.55741704,13.9138337 9.48225,13.8405 C9.40708296,13.7671663 9.34841688,13.6800838 9.30625,13.57925 C9.26408312,13.4784162 9.243,13.3693339 9.243,13.252 Z"
        id="?"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const Question = (props: Props) => (
  <svg
    {...props}
    style={mergeStyles(props.style, {
      width: props.size,
      height: props.size
    })}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M12 4C9.243 4 7 6.243 7 9h2c0-1.654 1.346-3 3-3s3 1.346 3 3c0 1.069-.454 1.465-1.481 2.255-.382.294-.813.626-1.226 1.038C10.981 13.604 10.995 14.897 11 15v2h2v-2.009c0-.024.023-.601.707-1.284.32-.32.682-.598 1.031-.867C15.798 12.024 17 11.1 17 9 17 6.243 14.757 4 12 4zM11 18H13V20H11z"
    />
  </svg>
);
